// extracted by mini-css-extract-plugin
module.exports = {"cls1":"StyledComponents-AppContainer_cls1__1V-YU","cls2":"StyledComponents-AppContainer_cls2__2o91V StyledComponents-AppContainer_cls1__1V-YU"};